import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/** The clinic's locations, for whichever portal is asking.
 *
 *  `/locations` is staff-only; the portal has its own narrower feed. One hook so no
 *  surface has to remember which endpoint it is entitled to.
 *
 *  `locations` is null while loading — callers must not decide whether to show location
 *  chrome from an empty array, or a two-site clinic flashes single-site UI on every load.
 */
export function useLocations({ includeInactive = false, portal = "staff" } = {}) {
  const [locations, setLocations] = useState(null);

  const load = useCallback(() => {
    const path = portal === "patient" ? "/patient/locations" : "/locations";
    const params = portal === "staff" && includeInactive ? { include_inactive: true } : undefined;
    api.get(path, { params })
      .then((r) => setLocations(r.data || []))
      .catch(() => setLocations([]));
  }, [includeInactive, portal]);

  useEffect(() => { load(); }, [load]);

  return { locations, reload: load };
}
